import React from 'react'
import styled from 'styled-components'
import SectionWrapper from '@components/ui/wrappers/SectionWrapper'
import { breakpoint, color } from '@configs/utilities'
import { HeadingH2, DescriptionDisplay1 } from '@components/ui/typography/Typography'
import ButtonScroll from '@components/ui/buttons/ButtonScroll'
import scrollIcon from '@assets/images/free-ai-tools/scrollIcon.svg'

const GeneratorCTASection = ({ title, description, buttonText }) => {
  return (
    <SectionWrapper sectionBackground={color.businessPlanLight}>
      <Wrapper>
        <HeadingH2>{title}</HeadingH2>
        <DescriptionDisplay1>{description}</DescriptionDisplay1>
        <ButtonScroll
          to="#ai-tools-form"
          buttonText={buttonText}
          icon={scrollIcon}
          margin="70px 0 50px"
          mdfontsize="18px"
          minWidth="300px"
        />
      </Wrapper>
    </SectionWrapper>
  )
}

export default GeneratorCTASection

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media screen and (min-width: ${breakpoint.md}) {
  }
`
